<form method="dialog" *ngIf="dialog">
    <button class="btn-close float-end"></button>
</form>

<div id="generate-unit" class="m-3">

    <h3 class="mb-3" *ngIf="standalone">Generar unidad</h3>

    <div *ngIf="standalone">
        <p class="fw-bold" *ngIf="unitID == 0">Se creará una unidad nueva.</p>
        <p class="fw-bold" *ngIf="unitID != 0">Unidad seleccionada: {{ unitName }}</p>
    </div>

    <form [formGroup]="unitForm" id="generate-unit-form" class="container mx-0 mb-3 px-0">
        <label class="d-block mb-3">
            <p class="fw-bold">Nombre:</p>
            <input type="text" class="form-control" formControlName="name" placeholder="Nombre">
        </label>
    
        <div class="d-block mb-3">
            <label class="w-25 d-inline-block me-3 mb-3">
                <p class="fw-bold">Número de horas:</p>
                <input type="number" class="form-control" min="0" formControlName="hours" placeholder="Horas">
            </label>
    
            <label class="w-25 d-inline-block me-3 mb-3">
                <p class="fw-bold">Número de lecciones:</p>
                <span class="fw-bold">{{ lessons }}</span>
                <input type="hidden" formControlName="lessons">
            </label>
        </div>

        <hr>

        <div class="d-block mb-3 row">
            <div class="col-4 d-inline-block mb-3 pe-4 border-black border-end">
                <label class="d-block mb-3">
                    <input type="checkbox" class="d-inline-block me-3" formControlName="imagesSearch">
                    <span class="fw-bold">Buscar imágenes</span>
                </label>
                
                <p>Si esta opción está activada, se buscarán imágenes de Google por cada enunciado.</p>
    
                <label class="d-inline-block me-3 mb-3">
                    <p class="fw-bold">Número de imágenes por enunciado</p>
                    <input type="number" class="form-control" min="0" formControlName="imagesPerHeading">
                </label>
            </div>
    
            <div class="col-4 d-inline-block mb-3 ps-4 border-black border-start border-end">
                <label class="d-block mb-3">
                    <input type="checkbox" class="d-inline-block me-3" formControlName="videosSearch">
                    <span class="fw-bold">Buscar vídeos</span>
                </label>
                
                <p>Si esta opción está activada, se buscarán vídeos de YouTube por cada lección.</p>
    
                <label class="d-inline-block me-3 mb-3">
                    <p class="fw-bold">Número de vídeos por lección</p>
                    <input type="number" class="form-control" min="0" formControlName="videosPerLesson">
                </label>
            </div>

            <div class="col-4 d-inline-block mb-3 ps-4 border-black border-start">
                <label class="d-block mb-3">
                    <input type="checkbox" class="d-inline-block me-3" formControlName="diagramsGenerate">
                    <span class="fw-bold">Generar diagramas</span>
                </label>
                
                <p>Si esta opción está activada, se generarán diagramas por cada lección.</p>
    
                <label class="d-inline-block me-3 mb-3">
                    <p class="fw-bold">Número de diagramas por lección</p>
                    <input type="number" class="form-control" min="0" formControlName="diagramsPerLesson">
                </label>
            </div>
        </div>

        <hr>

        <div class="d-block mb-3">
            <label class="d-block mb-3">
                <input type="checkbox" class="d-inline-block me-3" formControlName="generateSummary">
                <span class="fw-bold">Generar resumen</span>
            </label>

            <label class="d-block mb-3">
                <input type="checkbox" class="d-inline-block me-3" formControlName="generateGlossary">
                <span class="fw-bold">Generar glosario</span>
            </label>
        </div>

        <hr>

        <!--
        <div class="d-block mb-3">
            <span class="fw-bold">Tipo de criterios de aprendizaje:</span>
            <label class="d-block">
                <input class="me-2" type="radio" [(ngModel)]="criteriaType" value="obj">
                <span class="fw-bold">Capacidades y criterios de evaluación (Objetivos)</span>
            </label>
            <label class="d-block">
                <input class="me-2" type="radio" [(ngModel)]="criteriaType" value="text">
                <span class="fw-bold">Conocimientos / Capacidades cognitivas y prácticas (Texto)</span>
            </label>
        </div>
        -->
        
        <label class="d-block mb-3" *ngIf="criteriaType != ''">
            <p class="fw-bold">Criterios de aprendizaje:</p>
            <p class="fw-bold" *ngIf="criteriaType == 'obj'">Importante: Uno por línea, deben empezar por C o CE</p>
            <p class="fw-bold" *ngIf="criteriaType == 'text'">Importante: Uno por línea</p>
            <textarea rows="25" cols="50" class="form-control" formControlName="criteriaText"></textarea>
        </label>

        <hr>

        <label class="d-block mb-3">
            <p class="fw-bold">Perfil del alumno:</p>
            <input type="text" class="form-control" formControlName="studentProfile">
        </label>

        <hr>

        <label class="d-block mb-3">
            <p class="fw-bold">Instrucciones adicionales:</p>
            <textarea rows="5" cols="50" class="form-control" formControlName="additionalInstructions"></textarea>
        </label>
    </form>

    <div *ngIf="standalone">
        <div id="generate-unit-status" class="mb-3">
            <div id="generate-unit-loading" *ngIf="loading">
                <p><i class="fas fa-spinner fa-spin me-3"></i>{{ message }}</p>
                <p>Progreso: {{ progress }}%</p>
                <!-- <p>Tiempo transcurrido: {{ durationStr }}</p> -->
            </div>
            <div id="generate-unit-success" class="text-success" *ngIf="success">
                <i class="fas fa-check"></i>
                <span>¡Unidad generada correctamente!</span>
                <!-- <p>{{ message }}</p> -->
                <!-- <p>Progreso: {{ progress }}%</p> -->
                <p>Tiempo transcurrido: {{ durationStr }}</p>
            </div>
            <div id="generate-unit-error" class="text-danger" *ngIf="error">
                <i class="fas fa-times"></i>
                <p>Error: {{ errorText }}</p>
            </div>
        </div>
    
        <div id="generate-unit-info" *ngIf="success || error">
            <div class="mb-3">
                <button class="btn btn-primary me-3" (click)="showResult = !showResult">
                    <i class="far fa-rectangle-list"></i>
                    <span *ngIf="!showResult">Mostrar resultado</span>
                    <span *ngIf="showResult">Ocultar resultado</span>
                </button>
                <button class="btn btn-primary me-3" (click)="showLogs = !showLogs">
                    <i class="far fa-file-lines"></i>
                    <span *ngIf="!showLogs">Mostrar registros</span>
                    <span *ngIf="showLogs">Ocultar registros</span>
                </button>
            </div>
            <div *ngIf="showResult" class="mb-3">
                <ul *ngFor="let lesson of result">
                    <li [ngClass]="{'text-success' : !lesson.error, 'text-danger' : lesson.error }">
                        {{ lesson.message }}
                    </li>
                </ul>
            </div>
            <div *ngIf="showLogs" class="mb-3" [innerHTML]="logs"></div>
        </div>
        
        <div id="generate-unit-buttons" class="mb-3">
            <form method="dialog" class="d-inline-block" *ngIf="dialog">
                <button class="btn btn-danger me-3">
                    <i class="fas fa-times"></i>
                    <span>Cerrar</span>
                </button>
            </form>
    
            <button class="btn btn-primary me-3" onClick="javascript:window.location.reload()">
                <i class="fas fa-rotate-right"></i>
                <span>Recargar</span>
            </button>
    
            <button class="btn btn-success me-3" [attr.disabled]="loading || success ? 'disabled' : null" (click)="generateUnit()">
                <i class="fas fa-check"></i>
                <span>Generar</span>
            </button>
        </div>
    </div>
</div>
